import React from 'react'

// Icons
import { ReactComponent as Logo } from '../../assets/icons/icon-logo.inline.svg'
import { ReactComponent as Spinner } from '../../assets/icons/icon-loader.svg'

const LoadingCover = ({ visible }) => {
  return (
    <div className={visible ? 'loading-cover visible' : 'loading-cover'}>
      <div className="logo">
        <Logo />
      </div>

      <Spinner className="spinner" />
    </div>
  )
}

export default LoadingCover
